import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { MessageService } from 'primeng/api';
import { SystemService } from 'src/app/base/services/system.service';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { AdmisionService } from '../../services/admision.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
@Sentry.TraceClassDecorator()
export class HomeComponent {

    @ViewChild('captcha') captcha;

    extranjero: boolean = false;
    captcha_keysite: string = "6Ld0EXQUAAAAAFfhfAGMXm3hGHUFLlU-vCYvDkCe";
    errorHome: string[] = ["", "", ""];
    errorContacto: string[] = ["", "", ""];
    exampleHome: string = "Ej: 12345678";

    avisos: any[] = [];
    enlaces: any[] = [];

    logeando: boolean = false;

    recaptcha: boolean = false;
    habilitar_banner = false;

    cuenta = {
        usuario: "",
        dv: "",
        clave: "",
        captcha: null
    }

    constructor(
        private admisionService: AdmisionService,
        private erroresHandler: ErroresHandler,
        private systemService: SystemService,
        private messageService: MessageService,
    ) {
        this.getOpcionesProcesoMatricula();
        this.buscarEnlaces();

        this.buscarAvisos();

    }

    ngOnInit() {
        this.loadReCaptcha();

        if (!this.recaptcha) {
            setTimeout(() => {
                this.loadReCaptcha();
            }, 800);
        }

    }

    async getOpcionesProcesoMatricula(){
        try {
            this.systemService.setLoading(true);
            let data = await this.admisionService.getOpcionesProcesoMatricula();
            this.habilitar_banner = data.habilitar_banner_portal;
        } catch (e) {
            this.erroresHandler.processError(e, 'alert', 'Ha ocurrido un error.');
        }
        this.systemService.setLoading(false);
      }

    loadReCaptcha() {
        this.recaptcha = (window as any).grecaptcha;
    }

    async getLogin() {

        try {

            this.logeando = true;
            this.errorHome = ["", "", ""];

            let error = false;

            if (!this.extranjero) {
                if (this.cuenta.usuario == undefined || this.cuenta.usuario == "") {
                    this.errorHome[0] = "Ingresa tu RUT (sin dígito verificador).";
                    error = true;
                } else if (isNaN(Number(this.cuenta.usuario))) {
                    this.errorHome[0] = "El RUT ingresado no es válido.";
                    error = true;
                }
            } else {
                if (this.cuenta.usuario == undefined || this.cuenta.usuario == "") {
                    this.errorHome[0] = "Ingresa tu pasaporte";
                    error = true;
                } else if (isNaN(Number(this.cuenta.usuario))) {
                    this.errorHome[0] = "El Pasaporte ingresado es inválido.";
                    error = true;
                }
            }

            if (this.cuenta.clave == "" || this.cuenta.clave == undefined) {
                this.errorHome[1] = "Ingresa tu contraseña.";
                error = true;
            }

            if (this.cuenta.captcha == null || this.cuenta.captcha == false) {
                this.errorHome[2] = "Debes contestar la validación de Captcha.";
                error = true;
            }

            if (!error) {

                this.systemService.setLoading(true);

                let param = { rut: this.cuenta.usuario, dv: this.cuenta.dv, password: this.cuenta.clave }

                let userLogin = await this.admisionService.getLogin(param);

                if (userLogin != null) {
                    if (userLogin.valido) {

                        let param2 = { uid: this.cuenta.usuario, proyecto: 40, modulo: 177, token: userLogin.token, params: { codCarrera: userLogin.codCarrera, viaIngreso: userLogin.viaIngreso } }

                        let keyUser = await this.admisionService.saveKeyUser(param2);

                        switch (userLogin.etapa) {
                            case 0:

                                this.redirect(environment.RESULTADO_POSTULACION, keyUser.id);
                                break;

                            case 4:
                                this.redirect(environment.CERTIFICADOS, keyUser.id);
                                break;
                        }

                    } else {

                        this.errorHome[2] = "El usuario no se encuentra registrado o la clave es incorrecta.";
                        this.logeando = false;
                        this.cuenta.captcha = null;
                        this.captcha.reset();
                        this.messageService.add({ key: 'portal', severity: 'warn', summary: 'Advertencia', detail: 'El usuario no se encuentra registrado o la clave es incorrecta.' });

                    }
                }

                this.systemService.setLoading(false);

            }

        } catch (e) {
            this.erroresHandler.processError(e, 'alert', 'Ha ocurrido un error en el servicio login.');
            this.cuenta.captcha = null;
            this.captcha.reset();
            this.logeando = false;
            this.systemService.setLoading(false);
        }

    }

    async buscarEnlaces() {
        this.enlaces = await this.admisionService.buscarEnlaces();
    }

    async buscarAvisos() {
        this.avisos = await this.admisionService.buscarAvisos();
    }

    redirect(url: string, idSesion?: string) {

        if (idSesion == undefined) {
            window.location.replace(url);
        } else {
            window.location.replace(url + "?uid=" + idSesion);
        }
    }

    // ************* FUNCIONES DE VISTA *************

    reset_error(index: number) {
        switch (index) {
            case 0:
                if (this.extranjero) this.exampleHome = "Ej: 42235457";
                else this.exampleHome = "Ej: 12345678";
                break;

        }
    }

    onlyNumbers(e) {
        var keynum;
        if (window.event) {
            keynum = e.keyCode;
        } else if (e.which) {
            keynum = e.which;
        }
        if (keynum === 8 || keynum === 9 || e.keyCode === 37 || e.keyCode === 39) {
            e.prevent
            return true;
        }
        if (keynum >= 48 && keynum <= 57 || keynum == 46) {
            return true;
        } else {
            e.preventDefault();
        }
    }

    validate_rut() {
        if (!this.extranjero) this.cuenta.dv = this.admisionService.valida_rut(this.cuenta.usuario);
    }

    change_extranjero() {

        if (this.extranjero) this.exampleHome = "Ej: 42235457";
        else this.exampleHome = "Ej: 12345678";

        this.errorHome = ["", "", ""];

        this.cuenta = {
            usuario: "",
            dv: "",
            clave: "",
            captcha: null
        }

        if (this.cuenta.captcha != null) { this.cuenta.captcha.reset() }

    }

    // ************* CAPTCHA *************

    async validate_captcha(event) {

        let valida = await this.admisionService.validarCaptcha(event);

        this.cuenta.captcha = valida;

    }

    expire_captcha(event) {
        this.captcha.reset();
        this.cuenta.captcha = null;
    }

}
